import $ from 'jquery'
import store_fiche from "@/store/mods/consultations/fiche-consultations"
import ManageCertificatForm from '@/views/consultations/en-cours/certificats-medicaux/manage-certificat-form'

export default {
    name: 'param-certificat',
    components: {
        ManageCertificatForm
    },
    props: {
        evolution_id: Number,
        consultation_id: Number,
        user_id: Number,
        info_user: Object,
        group_id: Number,
        grs_toggler: Number,
        slug: String,
        liste_champs: Array,
        section_name: String,
        fcs_id: Number,
        is_edit: Number,
        existing_certificats: Array,
        info_patient: {
            type: Object,
            default: () => ({})
        },
    },
    data() {
        return {
            all_checked: false,
            one_is_checked: [],

            required_field_is_empty: false,
            is_error: false,
            error_message: '',
            save_loading: false,
            form_toggler: 0,
            c_slug: ''
        }
    },

    watch: {
        grs_toggler() {
            this.autoFillActiveFields()
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        autoFillActiveFields() {
            this.one_is_checked = []
            // this.liste_champs.forEach((el) => {
            //     if (el.is_active == 1) {
            //         this.one_is_checked.push(el.champ_id)
            //     }
            // });
        },

        toutSelectionner() {
            this.clearError()
            let is_checked = $('#select-all').is(":checked")

            if (is_checked) {
                this.one_is_checked = []

                this.liste_champs.forEach((el) => {
                    if (!this.existing_certificats.includes(el.champ)) {
                        this.one_is_checked.push(el.champ_id)
                    }
                });
                this.all_checked = true
                
            } else {
                this.one_is_checked = []
                this.all_checked = false
            }
        },

        onOneChange() {
            this.clearError()
            document.getElementById("select-all").checked = false;
        },

        clearError() {
            this.required_field_is_empty = false
            this.is_error = false
            this.error_message = ""
        },

        async nextToContentFilling() {
            if (this.one_is_checked.length == 0) {
                this.required_field_is_empty = true
                return;
            }

            await this.liste_champs.forEach((el, index) => {
                this.liste_champs[index].is_active = 0
                this.one_is_checked.forEach(is_checked => {
                    if (is_checked == el.champ_id) {
                        this.liste_champs[index].is_active = 1
                    }
                });
            });

            const formRef = 'mdl_param_form'+this.evolution_id+this.slug;
            this.$refs[formRef].click()

            await this.saveParam()

            this.form_toggler = (this.form_toggler == 0)?1:0

            const timestamp = new Date().getTime();
            this.c_slug = this.slug+timestamp

            setTimeout(() => {
                $('.certif-form-'+this.evolution_id+'-'+this.c_slug).modal('show')
            }, 600);
            
        },

        saveParam() {
            const data = {
                fcs_id: this.fcs_id,
                consultation_id: this.consultation_id,
                evolution_id: this.evolution_id,
                l_champs: this.liste_champs
            }
            this.save_loading = true
            const formRef = 'mdl_param_form'+this.evolution_id+this.slug;
            store_fiche.activateConsultationFicheChamp(data).then((response) => {
                if (response.success) {
                    
                    this.$refs[formRef].click()
                    this.$emit('emitFieldToFill')
                    this.successToast(response.message)
                } else {
                    this.error_message = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.$refs[formRef].click()
                this.errorToast("Une erreur s'est produite !")
            })
        },

        openFieldsModal() {
            // this.grs_toggler = (this.grs_toggler == 0)?1:0
            $('#param-'+this.evolution_id+'-'+this.slug).modal('show')
            this.autoFillActiveFields()
        },

        refreshContent() {
            this.$emit("emitRefreshData")
        }
    }
}